<template>
  <div class="wizard-step py-5">
    <h2 class="fw-bold text-uppercase text-center mb-3" :class="{ required }"><slot name="question"></slot></h2>
    <p class="text-center mb-5"><slot name="help"></slot></p>
    <slot></slot>
    <hr>
    <div class="d-flex justify-content-center gap-3">
      <button
          type="button"
          class="btn btn-outline-secondary"
          @click="$emit('back')"
          :disabled="wizard.isOnFirstPage"
      >
        <i class="fas fa-chevron-left fa-sm"></i>
        Zurück
      </button>
      <button
          type="button"
          class="btn btn-primary"
          @click="$emit('next')"
          :disabled="wizard.isOnLastPage"
      >
        Weiter
        <i class="fas fa-chevron-right fa-sm"></i>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  inject: ['wizard'],
  props: {
    required: {
      type: Boolean,
      default: true,
    }
  }
}
</script>